import { Overlay, OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal } from '@angular/cdk/portal';
import { ElementRef, Injectable, OnDestroy } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { AddToCartNotificationOverlayComponent } from '@x/ecommerce-shop/app/core/shop-overlay/components/add-to-cart-notification-overlay/add-to-cart-notification-overlay.component';
import { IShopOrderItem, TShopAssociationWithProducts } from '@x/ecommerce/shop-client';
import { Subscription } from 'rxjs';

@Injectable()
export class ShopOverlayService implements OnDestroy {
  private overlayRef: OverlayRef;
  private routerSubscription: Subscription = new Subscription();
  private navigationStarted = false;

  constructor(
    private overlay: Overlay,
    private router: Router,
  ) {
    this.routerSubscription.add(
      this.router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          this.navigationStarted = true;
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.routerSubscription.unsubscribe();
  }

  async showAddToBagNotification(
    itemAdded: IShopOrderItem,
    anchorElement: ElementRef,
    timeout: number = 3000,
    association?: TShopAssociationWithProducts,
  ) {
    try {
      if (this.navigationStarted) {
        this.navigationStarted = false;
        return;
      }

      if (this.overlayRef) {
        this.clearOverlay();
      }

      const positionStrategy = this.overlay
        .position()
        .flexibleConnectedTo(anchorElement)
        .withPositions([
          {
            originX: 'end',
            originY: 'bottom',
            overlayX: 'end',
            overlayY: 'top',
            offsetY: 10,
          },
        ]);

      this.overlayRef = this.overlay.create({ positionStrategy });
      this.overlayRef.addPanelClass('add-to-cart-overlay-pane');
      const portal = new ComponentPortal(AddToCartNotificationOverlayComponent);
      const componentRef = this.overlayRef.attach(portal);
      componentRef.instance.orderItem = itemAdded;
      if (association) componentRef.instance.association = association;
      componentRef.instance.overlayRef = this.overlayRef;
      componentRef.instance.closeNotificationTime = timeout;
    } catch (e) {
      this.clearOverlay();
    }
  }

  private clearOverlay() {
    if (this.overlayRef) {
      this.overlayRef.detach();
      this.overlayRef.dispose();
    }
  }
}
